(() => {
  const init = (section) => {
    if (!section || section.dataset.ecFaqReady === 'true') return;
    section.dataset.ecFaqReady = 'true';
    if (section.dataset.singleOpen !== 'true') return;

    const items = [...section.querySelectorAll('.ec-faq__item')];
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  };

  const initAll = (root = document) => {
    if (root.matches?.('[data-ec-faq]')) init(root);
    root.querySelectorAll('[data-ec-faq]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
